var _filter, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHdoublearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    height: 1.339414,
    width: 1.819394,
    x: -0.409697,
    y: -0.169707
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2071175
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.4643591 9.0000002 2.5356409-.0000002.000214 8h-2.5356409l3.5355339 4.535534 3.535534-4.535534h-2.535641l-.000214-7.9999997 2.535641-.0000001-3.53532-4.5355342",
    fill: "white",
    filter: "url(#a)",
    opacity: 0.5,
    stroke: "#000",
    strokeWidth: 2,
    transform: "matrix(0 -1 1 0 .000076 26.000032)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.0000763 15.535673-.0000005-2.535642 8.0000002-.000214v2.535641l4.535534-3.535534-4.535534-3.535534v2.535641l-7.9999998.000214-.0000005-2.5356403-4.5355339 3.5353193",
    fill: "white",
    stroke: "#fff",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.0000763 15.535673-.0000005-2.535642 8.0000002-.000214v2.535641l4.535534-3.535534-4.535534-3.535534v2.535641l-7.9999998.000214-.0000005-2.5356403-4.5355339 3.5353193",
    fill: "white",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdoublearrow);
export default __webpack_public_path__ + "static/media/hdoublearrow.716e3e1c1d5ea617a0a606dfc8ce4ead.svg";
export { ForwardRef as ReactComponent };